module.exports = __webpack_public_path__ + "static/news-new-e8f9bd43977dcd6d0c76518eb6f52952.png";